import { jsx as _jsx } from "react/jsx-runtime";
import { IllustratedMessage } from '@common/ui/images/illustrated-message';
import { ErrorIcon } from '@common/icons/material/Error';
import { Trans } from '@common/i18n/trans';
export function PageErrorMessage() {
    return (_jsx(IllustratedMessage, { className: "mt-40", image: _jsx("div", { children: _jsx(ErrorIcon, { size: "xl" }) }), imageHeight: "h-auto", title: _jsx(Trans, { message: "There was an issue loading this page" }), description: _jsx(Trans, { message: "Please try again later" }) }));
}
